<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>人员管理 / 处室管理</span>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <el-button type="primary" size="medium" :disabled="$regional.disableCRUD" @click="handleAdd">添加处室</el-button>
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table :data="department" size="medium">
              <el-table-column prop="name" label="处室名称" min-width="500"></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="$regional.disableCRUD" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="text" :disabled="$regional.disableCRUD" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>

    <department-edit-box :visible.sync="editorVisible" :identify="departmentInfo" @edit-result="initDepartment"></department-edit-box>

  </div>
</template>

<script>
import SecondNavBar from '@/components/common/SecondNavBar'
import DepartmentEditor from '@/components/district-admin/people/DepartmentEditor'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'department-edit-box': DepartmentEditor
  },

  data () {
    return {
      department: [],
      editorVisible: false,
      departmentInfo: {}
    }
  },

  watch: {

  },

  computed: {
  },

  mounted () {
    this.initDepartment()
  },

  methods: {
    initDepartment () {
      this.$xhrGet(`/acc/departments`).then(rs => {
        this.department = rs.data
      })
    },

    handleAdd () {
      this.editorVisible = true
      this.departmentInfo = {}
    },

    handleEdit (index, row) {
      this.editorVisible = true
      this.departmentInfo = row
    },

    handleDelete (index, row) {
      this.$xhrDelete(`/acc/departments/${row.value}`).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initDepartment()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 128px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/district-admin/people/DepartmentManage.vue